module.exports = __webpack_public_path__ + "static/media/tutorial-action-list-7-1.4ef31dbd.png";